import { Pencil, X } from 'lucide-react';
import { cn } from '@/utils/cn';
import { IconButton } from '@/components/atoms/IconButton';
import type { ExpandableEditRowProps } from './ExpandableEditRow.types';
import styles from './ExpandableEditRow.module.scss';

/**
 * Fila con etiqueta + icono de lápiz que, al pulsar, despliega debajo un editor
 * arbitrario (`children`). Controlada (`open`/`onToggle`) para que el contenedor
 * pueda colapsarla (p. ej. tras guardar). El guardado NO vive aquí: el editor y
 * el botón de guardar los gestiona el contenedor.
 */
export function ExpandableEditRow({
  label,
  value,
  open,
  onToggle,
  editAriaLabel,
  closeAriaLabel,
  children,
  className,
}: ExpandableEditRowProps) {
  return (
    <div className={cn(styles.row, className)}>
      <div className={styles.row__head}>
        <div className={styles.row__info}>
          <span className={styles.row__label}>{label}</span>
          {!open && value && <span className={styles.row__value}>{value}</span>}
        </div>
        <div className={styles.row__actions}>
          <IconButton
            icon={open ? X : Pencil}
            size="sm"
            onClick={onToggle}
            aria-label={open ? closeAriaLabel : editAriaLabel}
            aria-expanded={open}
          />
        </div>
      </div>

      {open && <div className={styles.row__editor}>{children}</div>}
    </div>
  );
}

export default ExpandableEditRow;
